import {
  ELVA_CRITICAL_FONT_SPECS,
  ELVA_FONT_LOAD_TIMEOUT_MS,
} from '@/shared/tailwind/font-manifest';

/**
 * Wait for critical Elva fonts, then reveal the page.
 * Pair with `elvaFontsPlugin()` preload tags in index.html.
 */
export async function ensureElvaFontsReady(): Promise<void> {
  if (typeof document === 'undefined') return;

  try {
    await Promise.race([
      Promise.all(ELVA_CRITICAL_FONT_SPECS.map((spec) => document.fonts.load(spec))),
      new Promise<void>((resolve) => {
        window.setTimeout(resolve, ELVA_FONT_LOAD_TIMEOUT_MS);
      }),
    ]);
  } catch {
    // Fall back to system fonts if loading fails.
  }

  document.documentElement.classList.add('fonts-ready');
}
